import clsx from "clsx";
import React, { useEffect, useState } from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import styles from "./checkbox.module.css";

interface CheckboxProps {
    elementID: string;
    defaultValue?: boolean;
    onChange?: () => void;
    className?: string;
}

export default function Checkbox({
    elementID,
    defaultValue,
    onChange,
    className,
}: CheckboxProps): JSX.Element {
    const [isChecked, setIsChecked] = useState(Boolean(defaultValue));

    function onClick(): void {
        setIsChecked(!isChecked);
    }

    useEffect(() => {
        const checkboxElement = document.getElementById(elementID);
        if (checkboxElement) {
            checkboxElement.setAttribute("checked", isChecked.toString());

            if (onChange) {
                onChange();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isChecked]);

    return (
        <div id={elementID} className={clsx(className, styles.checkboxContainer)} onClick={onClick}>
            <input type={"checkbox"} />
            {isChecked ? (
                <SVGIcon name={"round-checkbox-checked"} className={styles.checkboxSVG} />
            ) : (
                <SVGIcon name={"round-checkbox"} className={styles.checkboxSVG} />
            )}
        </div>
    );
}
